export default {
  headline: 'Kanały powiadomień',
  subheadline: 'Skonfiguruj kanały powiadomień, uzyskując dostęp do jednego z nich',
  headerType: 'Typ kanału',
};
